/* eslint-disable  */
//prettier-ignore
// we need to preserve the order of these imports and prevent to vscode on format on save to keep the order
/* ignore file */
import "chart.js/auto";
import "nprogress/nprogress.css";
import React from "react";
import "react-app-polyfill/stable";
import { createRoot } from "react-dom/client";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { HelmetProvider } from "react-helmet-async";
import "react-quill-new/dist/quill.snow.css";
import { Provider } from "react-redux";
import App from "src/App";
//import 'src/__mocks__';
import "src/assets/css/prism.css";
// import 'src/mixins/chartjs';
// import * as serviceWorker from 'src/serviceWorker';
import store from "src/store";
//
import "./i18n";

const runAfterInitialPaint = (callback) => {
  if (typeof window === "undefined") {
    callback();
    return;
  }

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(callback, { timeout: 2000 });
    return;
  }

  window.setTimeout(callback, 0);
};

const warmupNonCriticalResources = () => {
  const warmupTasks = [
    import("src/constants/planFeatures").then((module) =>
      module.preloadPlanFeaturesCatalog?.(),
    ),
    import("src/constants/permissionsCatalog").then((module) =>
      module.preloadPermissionsCatalog?.(),
    ),
  ];

  if (process.env.NODE_ENV === "production") {
    warmupTasks.push(import("src/prism-setup"));
  }

  Promise.allSettled(warmupTasks);
};

const BootReadySignal = () => {
  React.useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    window.dispatchEvent(new Event("arkadu:first-react-commit"));
  }, []);

  return null;
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <BootReadySignal />
      <App />
    </HelmetProvider>
  </Provider>,
);

if (typeof window !== "undefined") {
  window.addEventListener(
    "arkadu:first-react-commit",
    () => {
      runAfterInitialPaint(warmupNonCriticalResources);
    },
    { once: true },
  );
}

if (typeof window !== "undefined") {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      window.dispatchEvent(new Event("arkadu:app-mounted"));
    });
  });
}
